export function elapsedMatchSeconds(clock, now = Date.now()) {
  const base = Number.isFinite(clock?.baseSeconds) ? clock.baseSeconds : 0;
  if (clock?.startedAt == null) return base;
  return base + Math.max(0, Math.floor((now - clock.startedAt) / 1000));
}

export function timeoutSecondsLeft(endsAt, now = Date.now()) {
  if (!Number.isFinite(endsAt)) return 0;
  return Math.max(0, Math.ceil((endsAt - now) / 1000));
}
